import { Redirect, Route } from 'react-router';

type Props = {
    component?: React.ComponentClass | React.FunctionComponent;
    path: string;
    authenticated: boolean;
    render?: () => React.ReactNode;
    exact?: boolean;
};

const RedirectComponent = () => {
    return <Redirect to="/" />;
};

const PrivateRoute = ({
    component,
    authenticated,
    exact,
    render,
    ...rest
}: Props) => {
    return component ? (
        <Route
            {...rest}
            component={authenticated ? component : RedirectComponent}
            exact={exact}
        />
    ) : (
        <Route
            {...rest}
            render={authenticated ? render : RedirectComponent}
            exact={exact}
        />
    );
};

export default PrivateRoute;
